import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { emailApiReducer } from './reducers/apiSettings';
import { loginReducer } from './reducers/login';
import { getLeadReducer, leadListReducer } from './reducers/leads';
import { webhookSettingsReducer } from './reducers/webhookSettings';
import { sheetSettingsReducer } from './reducers/sheetSettings';
import { groupSettingsReducer } from './reducers/groupSettings';
import { automationSettingsReducer } from './reducers/automationSettings';
import { messageSegmentReducer } from './reducers/messageSegmentSettings';
import { messageGroupReducer } from './reducers/messageGroupSettings';
import { declineReasonReducer } from './reducers/declineReasonSettings';

const reducer = combineReducers({
	emailApi: emailApiReducer,
	userLogin: loginReducer,
	leadList: leadListReducer,
	leadInfo: getLeadReducer,
	webhookSettings: webhookSettingsReducer,
	sheetSettings: sheetSettingsReducer,
	groupSettings: groupSettingsReducer,
	automationSettings: automationSettingsReducer,
	messageSegmentsSettings: messageSegmentReducer,
	messageGroupsSettings: messageGroupReducer,
	declineReasons: declineReasonReducer
});

const userInfoFromStorage = localStorage.getItem('_gm_usr')
	? JSON.parse(localStorage.getItem('_gm_usr'))
	: null;

const initialState = {
	userLogin: { userInfo: userInfoFromStorage },
};

const middleware = [thunk];

const store = createStore(
	reducer,
	initialState,
	composeWithDevTools(applyMiddleware(...middleware))
);

export default store;
